import React from 'react';

type EyeIconProps = {
  size?: string;
};

export function EyeIcon({ size }: EyeIconProps): JSX.Element {
  return (
    <svg fill='none' height={size ?? '14'} viewBox='0 0 15 14' width={size ?? '15'} xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_5824_12144)'>
        <path
          clipRule='evenodd'
          d='M7.73479 4.45204C6.33576 4.45204 5.20163 5.58618 5.20163 6.9852C5.20163 8.38423 6.33576 9.51836 7.73479 9.51836C9.13381 9.51836 10.268 8.38423 10.268 6.9852C10.268 5.58618 9.13381 4.45204 7.73479 4.45204ZM6.21489 6.9852C6.21489 6.14579 6.89537 5.4653 7.73479 5.4653C8.5742 5.4653 9.25469 6.14579 9.25469 6.9852C9.25469 7.82462 8.5742 8.5051 7.73479 8.5051C6.89537 8.5051 6.21489 7.82462 6.21489 6.9852Z'
          fill='#485055'
          fillRule='evenodd'
        />
        <path
          clipRule='evenodd'
          d='M14.3902 5.97593C14.8491 6.57624 14.8497 7.39435 14.3902 7.9944C13.8723 8.67059 12.985 9.71465 11.8534 10.5939C10.7275 11.4686 9.30766 12.2204 7.7348 12.2204C6.16193 12.2204 4.74214 11.4686 3.6162 10.5939C2.48527 9.71521 1.59852 8.67198 1.0804 7.99576C0.856268 7.70659 0.734619 7.3511 0.734619 6.9852C0.734619 6.61932 0.85626 6.26384 1.08038 5.97467C1.59849 5.29845 2.48525 4.2552 3.6162 3.37654C4.74214 2.50176 6.16193 1.75 7.7348 1.75C9.30766 1.75 10.7275 2.50176 11.8534 3.37654C12.985 4.25575 13.8722 5.29974 14.3902 5.97593ZM1.88379 6.59211C2.37434 5.95173 3.20129 4.98203 4.23786 4.17669C5.28014 3.36691 6.48268 2.76326 7.7348 2.76326C8.98691 2.76326 10.1895 3.36691 11.2317 4.17669C12.2681 4.98187 13.0949 5.95134 13.5855 6.59173C13.7669 6.82905 13.7666 7.14213 13.5857 7.37836C13.0952 8.01874 12.2683 8.9884 11.2317 9.79371C10.1895 10.6035 8.98691 11.2071 7.7348 11.2071C6.48268 11.2071 5.28014 10.6035 4.23786 9.79371C3.20129 8.98837 2.37434 8.01867 1.88379 7.37829L1.8817 7.37558C1.79496 7.26393 1.74788 7.12658 1.74788 6.9852C1.74788 6.84383 1.79496 6.70648 1.8817 6.59483L1.88379 6.59211Z'
          fill='#485055'
          fillRule='evenodd'
        />
      </g>
      <defs>
        <clipPath id='clip0_5824_12144'>
          <rect fill='white' height='14' transform='translate(0.734619)' width='14' />
        </clipPath>
      </defs>
    </svg>
  );
}
